/**
 * Generated by orval v8.20.0 🍺
 * Do not edit manually.
 * Smart Sash Admin API
 * RESTful API for Smart Sash device management, user authentication, and system administration
 * OpenAPI spec version: 0.13.0.0
 */
import {
  useInfiniteQuery,
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  GetApiSashIqUserMeHistoryParams,
  GetApiSashIqUserMeParams,
  GetApiSashIqUserUserIdDetailsParams,
  GetApiSashIqUserUserIdHistoryParams,
  GetApiSashIqUserUserIdParams,
  MeSashIqDto,
  PostApiSashIqUserUserIdRecalculateParams,
  RecalculateRequestDto,
  RecalculateResponseDto,
  ScoreHistoryItemDto,
  UserSashIqHistoryDto,
  UserSashIqScoreDto
} from '../../models';

import { customInstance } from '../../../http/customInstance';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getApiSashIqUserUserId = (
    userId: string,
    params?: GetApiSashIqUserUserIdParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<UserSashIqScoreDto>(
      {url: `/api/sash-iq/user/${userId}`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetApiSashIqUserUserIdInfiniteQueryKey = (userId: string,
    params?: GetApiSashIqUserUserIdParams,) => {
    return [
    'infinite', `/api/sash-iq/user/${userId}`, ...(params ? [params] : [])
    ] as const;
    }

export const getGetApiSashIqUserUserIdQueryKey = (userId: string,
    params?: GetApiSashIqUserUserIdParams,) => {
    return [
    `/api/sash-iq/user/${userId}`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetApiSashIqUserUserIdInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getApiSashIqUserUserId>>>, TError = UserSashIqScoreDto>(userId: string,
    params?: GetApiSashIqUserUserIdParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiSashIqUserUserId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiSashIqUserUserIdInfiniteQueryKey(userId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiSashIqUserUserId>>> = ({ signal }) => getApiSashIqUserUserId(userId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: userId !== null && userId !== undefined, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiSashIqUserUserId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiSashIqUserUserIdInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getApiSashIqUserUserId>>>
export type GetApiSashIqUserUserIdInfiniteQueryError = UserSashIqScoreDto


export function useGetApiSashIqUserUserIdInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiSashIqUserUserId>>>, TError = UserSashIqScoreDto>(
 userId: string,
    params: undefined |  GetApiSashIqUserUserIdParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiSashIqUserUserId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiSashIqUserUserId>>,
          TError,
          Awaited<ReturnType<typeof getApiSashIqUserUserId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiSashIqUserUserIdInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiSashIqUserUserId>>>, TError = UserSashIqScoreDto>(
 userId: string,
    params?: GetApiSashIqUserUserIdParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiSashIqUserUserId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiSashIqUserUserId>>,
          TError,
          Awaited<ReturnType<typeof getApiSashIqUserUserId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiSashIqUserUserIdInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiSashIqUserUserId>>>, TError = UserSashIqScoreDto>(
 userId: string,
    params?: GetApiSashIqUserUserIdParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiSashIqUserUserId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiSashIqUserUserIdInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiSashIqUserUserId>>>, TError = UserSashIqScoreDto>(
 userId: string,
    params?: GetApiSashIqUserUserIdParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiSashIqUserUserId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiSashIqUserUserIdInfiniteQueryOptions(userId,params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetApiSashIqUserUserIdQueryOptions = <TData = Awaited<ReturnType<typeof getApiSashIqUserUserId>>, TError = UserSashIqScoreDto>(userId: string,
    params?: GetApiSashIqUserUserIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiSashIqUserUserId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiSashIqUserUserIdQueryKey(userId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiSashIqUserUserId>>> = ({ signal }) => getApiSashIqUserUserId(userId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: userId !== null && userId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiSashIqUserUserId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiSashIqUserUserIdQueryResult = NonNullable<Awaited<ReturnType<typeof getApiSashIqUserUserId>>>
export type GetApiSashIqUserUserIdQueryError = UserSashIqScoreDto


export function useGetApiSashIqUserUserId<TData = Awaited<ReturnType<typeof getApiSashIqUserUserId>>, TError = UserSashIqScoreDto>(
 userId: string,
    params: undefined |  GetApiSashIqUserUserIdParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiSashIqUserUserId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiSashIqUserUserId>>,
          TError,
          Awaited<ReturnType<typeof getApiSashIqUserUserId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiSashIqUserUserId<TData = Awaited<ReturnType<typeof getApiSashIqUserUserId>>, TError = UserSashIqScoreDto>(
 userId: string,
    params?: GetApiSashIqUserUserIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiSashIqUserUserId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiSashIqUserUserId>>,
          TError,
          Awaited<ReturnType<typeof getApiSashIqUserUserId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiSashIqUserUserId<TData = Awaited<ReturnType<typeof getApiSashIqUserUserId>>, TError = UserSashIqScoreDto>(
 userId: string,
    params?: GetApiSashIqUserUserIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiSashIqUserUserId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiSashIqUserUserId<TData = Awaited<ReturnType<typeof getApiSashIqUserUserId>>, TError = UserSashIqScoreDto>(
 userId: string,
    params?: GetApiSashIqUserUserIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiSashIqUserUserId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiSashIqUserUserIdQueryOptions(userId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiSashIqUserUserIdDetails = (
    userId: string,
    params?: GetApiSashIqUserUserIdDetailsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<UserSashIqScoreDto>(
      {url: `/api/sash-iq/user/${userId}/details`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetApiSashIqUserUserIdDetailsInfiniteQueryKey = (userId: string,
    params?: GetApiSashIqUserUserIdDetailsParams,) => {
    return [
    'infinite', `/api/sash-iq/user/${userId}/details`, ...(params ? [params] : [])
    ] as const;
    }

export const getGetApiSashIqUserUserIdDetailsQueryKey = (userId: string,
    params?: GetApiSashIqUserUserIdDetailsParams,) => {
    return [
    `/api/sash-iq/user/${userId}/details`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetApiSashIqUserUserIdDetailsInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getApiSashIqUserUserIdDetails>>>, TError = UserSashIqScoreDto>(userId: string,
    params?: GetApiSashIqUserUserIdDetailsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiSashIqUserUserIdDetails>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiSashIqUserUserIdDetailsInfiniteQueryKey(userId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiSashIqUserUserIdDetails>>> = ({ signal }) => getApiSashIqUserUserIdDetails(userId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: userId !== null && userId !== undefined, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiSashIqUserUserIdDetails>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiSashIqUserUserIdDetailsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getApiSashIqUserUserIdDetails>>>
export type GetApiSashIqUserUserIdDetailsInfiniteQueryError = UserSashIqScoreDto


export function useGetApiSashIqUserUserIdDetailsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiSashIqUserUserIdDetails>>>, TError = UserSashIqScoreDto>(
 userId: string,
    params: undefined |  GetApiSashIqUserUserIdDetailsParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiSashIqUserUserIdDetails>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiSashIqUserUserIdDetails>>,
          TError,
          Awaited<ReturnType<typeof getApiSashIqUserUserIdDetails>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiSashIqUserUserIdDetailsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiSashIqUserUserIdDetails>>>, TError = UserSashIqScoreDto>(
 userId: string,
    params?: GetApiSashIqUserUserIdDetailsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiSashIqUserUserIdDetails>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiSashIqUserUserIdDetails>>,
          TError,
          Awaited<ReturnType<typeof getApiSashIqUserUserIdDetails>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiSashIqUserUserIdDetailsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiSashIqUserUserIdDetails>>>, TError = UserSashIqScoreDto>(
 userId: string,
    params?: GetApiSashIqUserUserIdDetailsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiSashIqUserUserIdDetails>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiSashIqUserUserIdDetailsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiSashIqUserUserIdDetails>>>, TError = UserSashIqScoreDto>(
 userId: string,
    params?: GetApiSashIqUserUserIdDetailsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiSashIqUserUserIdDetails>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiSashIqUserUserIdDetailsInfiniteQueryOptions(userId,params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetApiSashIqUserUserIdDetailsQueryOptions = <TData = Awaited<ReturnType<typeof getApiSashIqUserUserIdDetails>>, TError = UserSashIqScoreDto>(userId: string,
    params?: GetApiSashIqUserUserIdDetailsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiSashIqUserUserIdDetails>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiSashIqUserUserIdDetailsQueryKey(userId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiSashIqUserUserIdDetails>>> = ({ signal }) => getApiSashIqUserUserIdDetails(userId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: userId !== null && userId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiSashIqUserUserIdDetails>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiSashIqUserUserIdDetailsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiSashIqUserUserIdDetails>>>
export type GetApiSashIqUserUserIdDetailsQueryError = UserSashIqScoreDto


export function useGetApiSashIqUserUserIdDetails<TData = Awaited<ReturnType<typeof getApiSashIqUserUserIdDetails>>, TError = UserSashIqScoreDto>(
 userId: string,
    params: undefined |  GetApiSashIqUserUserIdDetailsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiSashIqUserUserIdDetails>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiSashIqUserUserIdDetails>>,
          TError,
          Awaited<ReturnType<typeof getApiSashIqUserUserIdDetails>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiSashIqUserUserIdDetails<TData = Awaited<ReturnType<typeof getApiSashIqUserUserIdDetails>>, TError = UserSashIqScoreDto>(
 userId: string,
    params?: GetApiSashIqUserUserIdDetailsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiSashIqUserUserIdDetails>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiSashIqUserUserIdDetails>>,
          TError,
          Awaited<ReturnType<typeof getApiSashIqUserUserIdDetails>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiSashIqUserUserIdDetails<TData = Awaited<ReturnType<typeof getApiSashIqUserUserIdDetails>>, TError = UserSashIqScoreDto>(
 userId: string,
    params?: GetApiSashIqUserUserIdDetailsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiSashIqUserUserIdDetails>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiSashIqUserUserIdDetails<TData = Awaited<ReturnType<typeof getApiSashIqUserUserIdDetails>>, TError = UserSashIqScoreDto>(
 userId: string,
    params?: GetApiSashIqUserUserIdDetailsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiSashIqUserUserIdDetails>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiSashIqUserUserIdDetailsQueryOptions(userId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiSashIqUserMe = (
    params?: GetApiSashIqUserMeParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<MeSashIqDto>(
      {url: `/api/sash-iq/user/me`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetApiSashIqUserMeInfiniteQueryKey = (params?: GetApiSashIqUserMeParams,) => {
    return [
    'infinite', `/api/sash-iq/user/me`, ...(params ? [params] : [])
    ] as const;
    }

export const getGetApiSashIqUserMeQueryKey = (params?: GetApiSashIqUserMeParams,) => {
    return [
    `/api/sash-iq/user/me`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetApiSashIqUserMeInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getApiSashIqUserMe>>>, TError = unknown | null>(params?: GetApiSashIqUserMeParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiSashIqUserMe>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiSashIqUserMeInfiniteQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiSashIqUserMe>>> = ({ signal }) => getApiSashIqUserMe(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiSashIqUserMe>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiSashIqUserMeInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getApiSashIqUserMe>>>
export type GetApiSashIqUserMeInfiniteQueryError = unknown | null


export function useGetApiSashIqUserMeInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiSashIqUserMe>>>, TError = unknown | null>(
 params: undefined |  GetApiSashIqUserMeParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiSashIqUserMe>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiSashIqUserMe>>,
          TError,
          Awaited<ReturnType<typeof getApiSashIqUserMe>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiSashIqUserMeInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiSashIqUserMe>>>, TError = unknown | null>(
 params?: GetApiSashIqUserMeParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiSashIqUserMe>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiSashIqUserMe>>,
          TError,
          Awaited<ReturnType<typeof getApiSashIqUserMe>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiSashIqUserMeInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiSashIqUserMe>>>, TError = unknown | null>(
 params?: GetApiSashIqUserMeParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiSashIqUserMe>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiSashIqUserMeInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiSashIqUserMe>>>, TError = unknown | null>(
 params?: GetApiSashIqUserMeParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiSashIqUserMe>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiSashIqUserMeInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetApiSashIqUserMeQueryOptions = <TData = Awaited<ReturnType<typeof getApiSashIqUserMe>>, TError = unknown | null>(params?: GetApiSashIqUserMeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiSashIqUserMe>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiSashIqUserMeQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiSashIqUserMe>>> = ({ signal }) => getApiSashIqUserMe(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiSashIqUserMe>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiSashIqUserMeQueryResult = NonNullable<Awaited<ReturnType<typeof getApiSashIqUserMe>>>
export type GetApiSashIqUserMeQueryError = unknown | null


export function useGetApiSashIqUserMe<TData = Awaited<ReturnType<typeof getApiSashIqUserMe>>, TError = unknown | null>(
 params: undefined |  GetApiSashIqUserMeParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiSashIqUserMe>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiSashIqUserMe>>,
          TError,
          Awaited<ReturnType<typeof getApiSashIqUserMe>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiSashIqUserMe<TData = Awaited<ReturnType<typeof getApiSashIqUserMe>>, TError = unknown | null>(
 params?: GetApiSashIqUserMeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiSashIqUserMe>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiSashIqUserMe>>,
          TError,
          Awaited<ReturnType<typeof getApiSashIqUserMe>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiSashIqUserMe<TData = Awaited<ReturnType<typeof getApiSashIqUserMe>>, TError = unknown | null>(
 params?: GetApiSashIqUserMeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiSashIqUserMe>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiSashIqUserMe<TData = Awaited<ReturnType<typeof getApiSashIqUserMe>>, TError = unknown | null>(
 params?: GetApiSashIqUserMeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiSashIqUserMe>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiSashIqUserMeQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiSashIqUserMeHistory = (
    params?: GetApiSashIqUserMeHistoryParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<ScoreHistoryItemDto[] | null>(
      {url: `/api/sash-iq/user/me/history`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetApiSashIqUserMeHistoryInfiniteQueryKey = (params?: GetApiSashIqUserMeHistoryParams,) => {
    return [
    'infinite', `/api/sash-iq/user/me/history`, ...(params ? [params] : [])
    ] as const;
    }

export const getGetApiSashIqUserMeHistoryQueryKey = (params?: GetApiSashIqUserMeHistoryParams,) => {
    return [
    `/api/sash-iq/user/me/history`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetApiSashIqUserMeHistoryInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getApiSashIqUserMeHistory>>>, TError = unknown | null>(params?: GetApiSashIqUserMeHistoryParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiSashIqUserMeHistory>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiSashIqUserMeHistoryInfiniteQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiSashIqUserMeHistory>>> = ({ signal }) => getApiSashIqUserMeHistory(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiSashIqUserMeHistory>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiSashIqUserMeHistoryInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getApiSashIqUserMeHistory>>>
export type GetApiSashIqUserMeHistoryInfiniteQueryError = unknown | null


export function useGetApiSashIqUserMeHistoryInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiSashIqUserMeHistory>>>, TError = unknown | null>(
 params: undefined |  GetApiSashIqUserMeHistoryParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiSashIqUserMeHistory>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiSashIqUserMeHistory>>,
          TError,
          Awaited<ReturnType<typeof getApiSashIqUserMeHistory>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiSashIqUserMeHistoryInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiSashIqUserMeHistory>>>, TError = unknown | null>(
 params?: GetApiSashIqUserMeHistoryParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiSashIqUserMeHistory>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiSashIqUserMeHistory>>,
          TError,
          Awaited<ReturnType<typeof getApiSashIqUserMeHistory>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiSashIqUserMeHistoryInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiSashIqUserMeHistory>>>, TError = unknown | null>(
 params?: GetApiSashIqUserMeHistoryParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiSashIqUserMeHistory>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiSashIqUserMeHistoryInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiSashIqUserMeHistory>>>, TError = unknown | null>(
 params?: GetApiSashIqUserMeHistoryParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiSashIqUserMeHistory>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiSashIqUserMeHistoryInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetApiSashIqUserMeHistoryQueryOptions = <TData = Awaited<ReturnType<typeof getApiSashIqUserMeHistory>>, TError = unknown | null>(params?: GetApiSashIqUserMeHistoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiSashIqUserMeHistory>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiSashIqUserMeHistoryQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiSashIqUserMeHistory>>> = ({ signal }) => getApiSashIqUserMeHistory(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiSashIqUserMeHistory>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiSashIqUserMeHistoryQueryResult = NonNullable<Awaited<ReturnType<typeof getApiSashIqUserMeHistory>>>
export type GetApiSashIqUserMeHistoryQueryError = unknown | null


export function useGetApiSashIqUserMeHistory<TData = Awaited<ReturnType<typeof getApiSashIqUserMeHistory>>, TError = unknown | null>(
 params: undefined |  GetApiSashIqUserMeHistoryParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiSashIqUserMeHistory>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiSashIqUserMeHistory>>,
          TError,
          Awaited<ReturnType<typeof getApiSashIqUserMeHistory>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiSashIqUserMeHistory<TData = Awaited<ReturnType<typeof getApiSashIqUserMeHistory>>, TError = unknown | null>(
 params?: GetApiSashIqUserMeHistoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiSashIqUserMeHistory>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiSashIqUserMeHistory>>,
          TError,
          Awaited<ReturnType<typeof getApiSashIqUserMeHistory>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiSashIqUserMeHistory<TData = Awaited<ReturnType<typeof getApiSashIqUserMeHistory>>, TError = unknown | null>(
 params?: GetApiSashIqUserMeHistoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiSashIqUserMeHistory>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiSashIqUserMeHistory<TData = Awaited<ReturnType<typeof getApiSashIqUserMeHistory>>, TError = unknown | null>(
 params?: GetApiSashIqUserMeHistoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiSashIqUserMeHistory>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiSashIqUserMeHistoryQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const postApiSashIqUserUserIdRecalculate = (
    userId: string,
    recalculateRequestDto?: RecalculateRequestDto,
    params?: PostApiSashIqUserUserIdRecalculateParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<RecalculateResponseDto>(
      {url: `/api/sash-iq/user/${userId}/recalculate`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: recalculateRequestDto,
        params, signal
    },
      options);
    }




export const getPostApiSashIqUserUserIdRecalculateMutationOptions = <TError = RecalculateResponseDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiSashIqUserUserIdRecalculate>>, TError,{userId: string;data?: RecalculateRequestDto;params?: PostApiSashIqUserUserIdRecalculateParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiSashIqUserUserIdRecalculate>>, TError,{userId: string;data?: RecalculateRequestDto;params?: PostApiSashIqUserUserIdRecalculateParams}, TContext> => {

const mutationKey = ['postApiSashIqUserUserIdRecalculate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiSashIqUserUserIdRecalculate>>, {userId: string;data?: RecalculateRequestDto;params?: PostApiSashIqUserUserIdRecalculateParams}> = (props) => {
          const {userId,data,params} = props ?? {};

          return  postApiSashIqUserUserIdRecalculate(userId,data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiSashIqUserUserIdRecalculateMutationResult = NonNullable<Awaited<ReturnType<typeof postApiSashIqUserUserIdRecalculate>>>
    export type PostApiSashIqUserUserIdRecalculateMutationBody = RecalculateRequestDto | undefined
    export type PostApiSashIqUserUserIdRecalculateMutationError = RecalculateResponseDto

    export const usePostApiSashIqUserUserIdRecalculate = <TError = RecalculateResponseDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiSashIqUserUserIdRecalculate>>, TError,{userId: string;data?: RecalculateRequestDto;params?: PostApiSashIqUserUserIdRecalculateParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiSashIqUserUserIdRecalculate>>,
        TError,
        {userId: string;data?: RecalculateRequestDto;params?: PostApiSashIqUserUserIdRecalculateParams},
        TContext
      > => {
      return useMutation(getPostApiSashIqUserUserIdRecalculateMutationOptions(options), queryClient);
    }
    export const getApiSashIqUserUserIdHistory = (
    userId: string,
    params?: GetApiSashIqUserUserIdHistoryParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<UserSashIqHistoryDto>(
      {url: `/api/sash-iq/user/${userId}/history`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetApiSashIqUserUserIdHistoryInfiniteQueryKey = (userId: string,
    params?: GetApiSashIqUserUserIdHistoryParams,) => {
    return [
    'infinite', `/api/sash-iq/user/${userId}/history`, ...(params ? [params] : [])
    ] as const;
    }

export const getGetApiSashIqUserUserIdHistoryQueryKey = (userId: string,
    params?: GetApiSashIqUserUserIdHistoryParams,) => {
    return [
    `/api/sash-iq/user/${userId}/history`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetApiSashIqUserUserIdHistoryInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getApiSashIqUserUserIdHistory>>>, TError = UserSashIqHistoryDto>(userId: string,
    params?: GetApiSashIqUserUserIdHistoryParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiSashIqUserUserIdHistory>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiSashIqUserUserIdHistoryInfiniteQueryKey(userId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiSashIqUserUserIdHistory>>> = ({ signal }) => getApiSashIqUserUserIdHistory(userId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: userId !== null && userId !== undefined, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiSashIqUserUserIdHistory>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiSashIqUserUserIdHistoryInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getApiSashIqUserUserIdHistory>>>
export type GetApiSashIqUserUserIdHistoryInfiniteQueryError = UserSashIqHistoryDto


export function useGetApiSashIqUserUserIdHistoryInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiSashIqUserUserIdHistory>>>, TError = UserSashIqHistoryDto>(
 userId: string,
    params: undefined |  GetApiSashIqUserUserIdHistoryParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiSashIqUserUserIdHistory>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiSashIqUserUserIdHistory>>,
          TError,
          Awaited<ReturnType<typeof getApiSashIqUserUserIdHistory>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiSashIqUserUserIdHistoryInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiSashIqUserUserIdHistory>>>, TError = UserSashIqHistoryDto>(
 userId: string,
    params?: GetApiSashIqUserUserIdHistoryParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiSashIqUserUserIdHistory>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiSashIqUserUserIdHistory>>,
          TError,
          Awaited<ReturnType<typeof getApiSashIqUserUserIdHistory>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiSashIqUserUserIdHistoryInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiSashIqUserUserIdHistory>>>, TError = UserSashIqHistoryDto>(
 userId: string,
    params?: GetApiSashIqUserUserIdHistoryParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiSashIqUserUserIdHistory>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiSashIqUserUserIdHistoryInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiSashIqUserUserIdHistory>>>, TError = UserSashIqHistoryDto>(
 userId: string,
    params?: GetApiSashIqUserUserIdHistoryParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiSashIqUserUserIdHistory>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiSashIqUserUserIdHistoryInfiniteQueryOptions(userId,params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetApiSashIqUserUserIdHistoryQueryOptions = <TData = Awaited<ReturnType<typeof getApiSashIqUserUserIdHistory>>, TError = UserSashIqHistoryDto>(userId: string,
    params?: GetApiSashIqUserUserIdHistoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiSashIqUserUserIdHistory>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiSashIqUserUserIdHistoryQueryKey(userId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiSashIqUserUserIdHistory>>> = ({ signal }) => getApiSashIqUserUserIdHistory(userId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: userId !== null && userId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiSashIqUserUserIdHistory>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiSashIqUserUserIdHistoryQueryResult = NonNullable<Awaited<ReturnType<typeof getApiSashIqUserUserIdHistory>>>
export type GetApiSashIqUserUserIdHistoryQueryError = UserSashIqHistoryDto


export function useGetApiSashIqUserUserIdHistory<TData = Awaited<ReturnType<typeof getApiSashIqUserUserIdHistory>>, TError = UserSashIqHistoryDto>(
 userId: string,
    params: undefined |  GetApiSashIqUserUserIdHistoryParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiSashIqUserUserIdHistory>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiSashIqUserUserIdHistory>>,
          TError,
          Awaited<ReturnType<typeof getApiSashIqUserUserIdHistory>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiSashIqUserUserIdHistory<TData = Awaited<ReturnType<typeof getApiSashIqUserUserIdHistory>>, TError = UserSashIqHistoryDto>(
 userId: string,
    params?: GetApiSashIqUserUserIdHistoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiSashIqUserUserIdHistory>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiSashIqUserUserIdHistory>>,
          TError,
          Awaited<ReturnType<typeof getApiSashIqUserUserIdHistory>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiSashIqUserUserIdHistory<TData = Awaited<ReturnType<typeof getApiSashIqUserUserIdHistory>>, TError = UserSashIqHistoryDto>(
 userId: string,
    params?: GetApiSashIqUserUserIdHistoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiSashIqUserUserIdHistory>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiSashIqUserUserIdHistory<TData = Awaited<ReturnType<typeof getApiSashIqUserUserIdHistory>>, TError = UserSashIqHistoryDto>(
 userId: string,
    params?: GetApiSashIqUserUserIdHistoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiSashIqUserUserIdHistory>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiSashIqUserUserIdHistoryQueryOptions(userId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






